


































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { machineBalance, cardMachine, userInfo, convert } from '../api';
import moment from 'moment';
import { isWeiXin } from '@/common/ts/common';
import { Popup, Dialog, Picker, Toast } from 'vant';
Vue.use(Popup).use(Dialog).use(Picker).use(Toast);
@Component
export default class UserCenter extends Vue {
  userCenterShow = false;
  confirmConvertVar = false;
  userInfo: any = {}; // 用户信息
  addressVar = false; // 地址选择变量
  successConvertVar = false; // 兑换成功显示
  tabActiveIndex = 0;
  // noRice = true;
  selectAddress = ''; // 选中的地址
  userTab = [
    {
      text: '我的大米',
      index: 0,
    },
    {
      text: '我的卡券',
      index: 1,
    },
  ];
  successConvert: any = {};
  machineList = [];
  machineB = 0;
  homeInfo = {};

  get columns() {
    return this.machineList.map((item: any) => item.position);
  }
  get noRice() {
    return this.userInfo.riceNum < 3;
  }
  get machineId() {
    return (this.machineList.filter(
      (item: any) => this.selectAddress === item.position,
    )[0] as any).id;
  }

  @Watch('selectAddress')
  onSelectAddressChange() {
    const temp: any = this.machineList.filter(
      (item: any) => this.selectAddress === item.position,
    )[0];
    machineBalance(temp.id).then((res: any) => {
      this.machineB = res.data;
    });
  }
  async created() {
    await this.fetchUserInfo();
    await this.fetchCommonInfo();
  }
  changeTab(index: number) {
    this.tabActiveIndex = index;
  }
  // 获取门店、余额相关信息
  async fetchCommonInfo() {
    // const res = await balance();
    const machine = await cardMachine();
    // const homeInfoRes = await homeInfo();
    this.machineList = machine.data;
  }
  // 兑换优惠券
  handleConvert() {
    console.log('confirm');
    if (this.userInfo.riceNum < 3) {
      return;
    }
    this.confirmConvertVar = true;
  }
  // 获取用户信息
  async fetchUserInfo() {
    const id = this._getWxId();
    const res = await userInfo(id);
    this.userInfo = res.data;
  }
  // 确认兑换
  async handleConfirmConvert() {
    if (!this.selectAddress) {
      Toast('请选择兑换地址！');
      return;
    }
    const res: any = await convert(this.machineId, this._getWxId());
    if (res.code === 200) {
      this.confirmConvertVar = false;
      this.successConvertVar = true;
      this.successConvert = res.data;
      this.fetchUserInfo();
    } else if (res.code === 505) {
      localStorage.removeItem('unionid');
      window.location.reload();
    } else {
      Toast(res.msg);
    }
  }
  onConfirm(e: string) {
    this.selectAddress = e;
    this.addressVar = false;
  }
  handleSuccessConvert() {
    this.successConvertVar = false;
  }
  handleUserCenter() {
    this.userCenterShow = !this.userCenterShow;
  }
  _getWxId() {
    let id = '';
    const wxid = window.localStorage.getItem('unionid');
    if (isWeiXin() && wxid) {
      id = wxid as string;
    }
    return id;
  }
  transitionTime(time: string) {
    return moment(+time * 1000).format('YYYY/MM/DD');
  }
  copy() {
    Toast('复制成功');
  }
}
